<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-modal v-drag-modal title="数据统计" :visible="showTubeView" width="50%" destroyOnClose @ok="closeTubeView"
    @cancel="closeTubeView" style="position: absolute; left: 18rem; z-index: 999; top: 3rem">
    <a-button type="primary" style="margin-bottom: 8px; margin-right: 20px;" @click="exportHandle('pipe')"
      :loading="exportLoading">导出管点信息</a-button>
    <a-button type="primary" style="margin-bottom: 8px; margin-right: 20px" @click="exportHandle('line')"
      :loading="exportLoading">导出管线信息</a-button>

    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="管径">
      </a-tab-pane>
      <a-tab-pane key="2" tab="管材" force-render>
      </a-tab-pane>
      <a-tab-pane key="3" tab="特征点">
      </a-tab-pane>
      <a-tab-pane key="4" tab="附属物">
      </a-tab-pane>
      <a-tab-pane key="5" tab="构筑物">
      </a-tab-pane>
    </a-tabs>

    <!-- 加载状态 -->
    <div v-if="dataListLoading" style="text-align: center; padding: 40px;">
      <a-spin size="large" />
      <div style="margin-top: 16px; color: #666;">数据加载中...</div>
    </div>

    <!-- 图表内容 -->
    <div v-else-if="hasData && echartData && echartData.xdata && echartData.xdata.length > 0">
      <BarChart :data="echartData"></BarChart>
    </div>

    <!-- 无数据状态 -->
    <div v-else style="text-align: center; padding: 40px; color: #999;">
      <a-icon type="inbox" style="font-size: 48px; margin-bottom: 16px;" />
      <div>暂无数据</div>
      <div style="font-size: 12px; margin-top: 8px; color: #ccc;">
        当前查询区域没有找到相关数据
      </div>
    </div>
  </a-modal>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import BarChart from '@/components/Charts/BarChart'
export default {
  components: {
    BarChart
  },
  data () {
    return {
      queryUrl: '/pipe-network/gis/pipe-networks/region/statistics',

      pipeDiameterList: [], // 管径
      pipeMaterialList: [], // 管材
      featurePointList: [], // 特征点
      appendageList: [], // 附属物
      structureList: [], // 构筑物
      dataListLoading: false,
      exportLoading: false,
      deleteLoading: false,
      exportFileName: '数据统计.xlsx',
      exportDataUrl: 'pipe-network/gis/pipe-networks/region/statistics/export',
      exportLineDataUrl: 'pipe-network/gis/pipe-lines/region/statistics/export',
      deleteUrl: '/pipe-network/gis/pipe-networks/region/statistics/delete',
      showTubeView: false,
      arr: [],
      echartData: {}
    }
  },
  computed: {
    // 判断是否有数据
    hasData () {
      // 确保数据是数组且不为空
      const hasPipeDiameter = Array.isArray(this.pipeDiameterList) && this.pipeDiameterList.length > 0;
      const hasPipeMaterial = Array.isArray(this.pipeMaterialList) && this.pipeMaterialList.length > 0;
      const hasFeaturePoint = Array.isArray(this.featurePointList) && this.featurePointList.length > 0;
      const hasAppendage = Array.isArray(this.appendageList) && this.appendageList.length > 0;
      const hasStructure = Array.isArray(this.structureList) && this.structureList.length > 0;

      return hasPipeDiameter || hasPipeMaterial || hasFeaturePoint || hasAppendage || hasStructure;
    }
  },
  methods: {
    moment,


    // 导出
    exportHandle (item) {
      let exportUrl = ''
      if (item == 'pipe') {
        exportUrl = this.exportDataUrl
      } else {
        exportUrl = this.exportLineDataUrl
      }

      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        linestring: this.arr
      }
      const params2 = {
        responseType: 'arraybuffer',
        headers: {
          Authorization: token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${exportUrl}`
      axios
        .post(url, params, params2)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },

    // 删除区域数据 - 直接显示确认对话框，不显示模态框
    deleteHandle (coordinates) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: '确定要删除此区域内的管点,物探点信息？',
        okText: '确认',
        cancelText: '取消',
        okType: 'danger',
        onOk () {
          that.executeDelete(coordinates)
        }
      })
    },

    // 执行删除操作
    executeDelete (coordinates) {
      this.deleteLoading = true
      const params = {
        linestring: coordinates
      }

      this.$http
        .post(this.deleteUrl, params)
        .then(({ data }) => {
          this.deleteLoading = false
          this.$message.success('删除成功')
          // 刷新数据或通知父组件
          this.$emit('delete-success')
        })
        .catch(() => {
          this.deleteLoading = false
          this.$message.error('删除失败，请重试')
        })
    },
    edit (arr) {
      console.log('显示弹窗=====', arr)
      this.showTubeView = true

      // 重置数据状态
      this.pipeDiameterList = []
      this.pipeMaterialList = []
      this.featurePointList = []
      this.appendageList = []
      this.structureList = []
      this.echartData = {}

      if (arr) {
        this.arr = arr
        this.getDataList()
      }
    },
    callback (key) {
      console.log(key)
      if (key == 1) {
        this.getEchartList(this.pipeDiameterList)
      } else if (key == 2) {
        this.getEchartList(this.pipeMaterialList)
      } else if (key == 3) {
        this.getEchartList(this.featurePointList)
      } else if (key == 4) {
        this.getEchartList(this.appendageList)
      } else {
        this.getEchartList(this.structureList)
      }
    },
    getDataList () {
      console.log('getDataList=====加载数据')
      this.dataListLoading = true
      const params = {
        linestring: this.arr
      }
      this.$http
        .post(this.queryUrl, params)
        .then(({ data }) => {
          this.dataListLoading = false
          // 确保数据不为null或undefined，如果为空则设置为空数组
          this.pipeDiameterList = data.pipeDiameterList || []
          this.pipeMaterialList = data.pipeMaterialList || []
          this.featurePointList = data.featurePointList || []
          this.appendageList = data.appendageList || []
          this.structureList = data.structureList || []
          this.getEchartList(this.pipeDiameterList)
        })
        .catch(() => {
          this.dataListLoading = false
          // 请求失败时也设置为空数组，确保显示无数据状态
          this.pipeDiameterList = []
          this.pipeMaterialList = []
          this.featurePointList = []
          this.appendageList = []
          this.structureList = []
        })
    },

    getEchartList (data) {
      const xdata = []
      const ydata = []
      let unit = ''

      // 如果没有数据，设置空的图表数据
      if (!data || data.length === 0) {
        this.echartData = {
          xdata: [],
          seriseData: [
            {
              type: 'bar',
              data: [],
              barWidth: 20
            }
          ],
          unit: ''
        }
        return
      }

      data.map(item => {
        const value = item.propertiesValue
        const itemUnit = value.replace(/[0-9]*/g, '').replace(/\./, '')
        const itemVal = parseFloat(value)
        if (!unit && itemUnit) {
          unit = itemUnit
        }
        xdata.push(item.propertiesName)
        ydata.push(itemVal)
      })
      this.echartData = {
        xdata: xdata,
        seriseData: [
          {
            type: 'bar',
            data: ydata,
            barWidth: 20 // 柱图宽度
          }
        ],
        unit: unit
      }
      console.log(this.echartData)
    },
    closeTubeView () {
      this.showTubeView = false
      this.$parent.clearKuang()
    }
  }
}
</script>

<style lang="less" scoped></style>
